import * as React from "react";
import { RouteWithoutLayout } from 'react-admin';
import CustomerContract from "../pages/CustomerContract";

// eslint-disable-next-line import/no-anonymous-default-export
export default [
    <RouteWithoutLayout path="/customer/subscription/:id/contract/:key" component={CustomerContract} />,
];
